import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2, HardHat } from "lucide-react";
import { toast } from "sonner";
import { useCompanionAuth } from "@/context/CompanionAuthContext";
import { Input } from "@/components/ui/input";

const CompanionLogin = () => {
  const { user, ready, login } = useCompanionAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  if (ready && user) return <Navigate to="/companion" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email.trim().toLowerCase(), password);
      navigate("/companion", { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Sign-in failed.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-crest-navy text-white flex flex-col font-body" data-testid="companion-login-page">
      <div className="flex-1 flex items-center justify-center px-5 py-10">
        <form onSubmit={onSubmit} className="w-full max-w-sm">
          <div className="flex flex-col items-center mb-10">
            <div className="h-16 w-16 rounded-xl bg-crest-green grid place-items-center mb-4">
              <HardHat className="h-8 w-8 text-crest-gold" />
            </div>
            <h1 className="font-display text-2xl font-bold">Cresttor Companion</h1>
            <p className="text-xs uppercase tracking-[0.22em] text-crest-gold mt-1">Crew sign in</p>
          </div>

          <div className="space-y-4">
            <div>
              <label className="text-xs uppercase tracking-[0.14em] text-white/70 font-medium">Email</label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-2 h-12 bg-white/10 border-white/20 text-white placeholder:text-white/40"
                data-testid="companion-email"
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.14em] text-white/70 font-medium">Password</label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-2 h-12 bg-white/10 border-white/20 text-white placeholder:text-white/40"
                data-testid="companion-password"
              />
            </div>
            <button
              type="submit"
              disabled={busy}
              data-testid="companion-login-submit"
              className="w-full inline-flex items-center justify-center gap-2 rounded-md bg-crest-green hover:bg-crest-green-700 disabled:opacity-60 h-12 font-semibold text-white transition-colors"
            >
              {busy && <Loader2 className="h-4 w-4 animate-spin" />}
              Sign in
            </button>
          </div>

          <p className="mt-8 text-center text-[11px] text-white/40 uppercase tracking-[0.18em]">
            Cresttor Construction Ltd · Internal use only
          </p>
        </form>
      </div>
    </div>
  );
};

export default CompanionLogin;
